import React from 'react';
import Select, { MultiValue, SingleValue, components } from 'react-select';
import styled from 'styled-components';
export interface DropdownOptions {
  value: number | string;
  label: string;
}
interface DropdownProps {
  label?: string;
  name?: string;
  options: DropdownOptions[] | any;
  value: DropdownOptions | DropdownOptions[] | null | undefined;
  isMulti?: boolean | undefined;
  onChange: (
    option: MultiValue<DropdownOptions> | SingleValue<DropdownOptions> | null
  ) => void;
  error?: string | undefined;
  isClearable?: boolean;
  isSearchable?: boolean;
  placeholder?: string;
}
export default function ListBox(props: DropdownProps) {
  const {
    label,
    name,
    value,
    isMulti,
    isClearable,
    isSearchable,
    placeholder,
  } = props;

  const Option = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label style={{ marginLeft: '8px', marginBottom: 0 }}>
            {props.label}
          </label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props: any) => {
    let labelToBeDisplayed = `${props.data.label}`;

    return (
      <components.MultiValue {...props}>
        <span>{labelToBeDisplayed}</span>
      </components.MultiValue>
    );
  };

  const getOptions = () => [...props.options];

  const handleOnChange = (selected: any, event: any) => {
    if (selected !== null && selected.length > 0) {
      let result: any = [];
      if (selected.length === props.options.length) {
        if (event.action === 'select-option') {
          result = [...props.options];
        }
        return props.onChange(result);
      }
    }

    return props.onChange(selected);
  };

  return (
    <SelectWrapper>
      {label && <label htmlFor={name}>{label}</label>}
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        name={name}
        value={value}
        options={getOptions()}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        placeholder={placeholder ? placeholder : 'Select...'}
        isMulti={isMulti}
        onChange={handleOnChange}
        components={{
          Option,
          MultiValue,
        }}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'none',
            fontFamily: 'Gilroy-Medium',
            fontSize: '16px',
            height: '50px',
            padding: '0 14px',
            backgroundColor: '#f5f5f9',
            cursor: 'pointer',
            transition: 'all 0.5s ease-in-out',
            borderRadius: '3px',
            boxShadow: 'none',
          }),
          singleValue: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 700,
          }),
          multiValue: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 700,
            background: '#fff',
            color: '#8181A5',
            margin: '2px',
            borderRadius: '6px',
            padding: '2px',
          }),
          placeholder: (baseStyles) => ({
            ...baseStyles,
            fontSize: '16px',
            color: '#838383',
          }),
          dropdownIndicator: () => ({
            padding: 0,
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            paddingLeft: 0,
            maxHeight: '50px',
            overflowY: 'auto',
          }),
          menu: () => ({
            borderRadius: '4px',
            border: 'none',
          }),
          menuList: (baseStyles) => ({
            ...baseStyles,
            paddingBottom: 0,
            borderRadius: '4px',
            position: 'absolute',
            width: '100%',
            boxShadow: '0px 6px 20px rgba(153, 155, 168, 0.1)',
            zIndex: 7,
            maxHeight: '140px',
            overflowY: 'auto',
            background: '#fff',
          }),
          option: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 700,
            cursor: 'pointer',
            padding: '12px 17px',
            display: 'flex',
            alignItems: 'center',
          }),
        }}
        isSearchable={isSearchable}
        // instanceId={useId()}
        isClearable={isClearable}
      />
    </SelectWrapper>
  );
}

const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
